module.exports = __webpack_public_path__ + "assets/img/img253.9d3854d8.png";